// SPDX-License-Identifier: AGPL-3.0-or-later

import {Button} from '@app/features/ui/button/Button';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import styles from '@app/features/voice_scene/components/VoiceSceneTv.module.css';
import type {MessageDescriptor} from '@lingui/core';
import {useLingui} from '@lingui/react/macro';
import type React from 'react';

// An icon button of the TV's glass group, named by its label (also its tooltip).
export function TvIconButton({
	label,
	icon,
	onClick,
}: {
	label: MessageDescriptor;
	icon: React.ReactNode;
	onClick: () => void;
}) {
	const {i18n} = useLingui();
	const text = i18n._(label);
	return (
		<Tooltip text={text} data-flx="voice-scene.voice-scene-tv-icon-button.tv-icon-button.tooltip">
			<Button
				small
				square
				variant="ghost"
				className={styles.glassButton}
				icon={icon}
				aria-label={text}
				onClick={onClick}
				data-flx="voice-scene.voice-scene-tv-icon-button.tv-icon-button.button.click"
			/>
		</Tooltip>
	);
}
